import {OnDestroy$} from "@pdtec/ngx-observable-lifecycle";
import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {NgClass} from "@angular/common";
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-hotel-price-calendar-skeleton',
  templateUrl: environment.mobile ? './calendar-skeleton.component.mobile.html' : './calendar-skeleton.component.html',
  styleUrls: environment.mobile ? ['./calendar-skeleton.component.mobile.scss'] : ['./calendar-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass
  ]
})
export class HotelPriceCalendarSkeletonComponent extends OnDestroy$ implements OnInit, OnDestroy {
  @Input() isShort: boolean | null;
  @Input() position: string | null;
  @Input() rowsCount: number | null;

  calendarRows = [1,2,3,4,5,6,7,8];
  calendarCols = [1,2,3,4,5,6,7,8];

  constructor() {
    super();
  }

  ngOnInit() {
    const defaultCols = environment.mobile ? 8 : 12;
    const defaultRows = environment.mobile ? 7 : 8;
    this.calendarCols = Array.from({length: defaultCols}, (_, i) => i + 1);
    this.calendarRows = Array.from({length: defaultRows}, (_, i) => i + 1);

    if (this.rowsCount && this.rowsCount > 0) {
      this.calendarRows = Array.from({length: this.rowsCount}, (_, i) => i + 1);
    }

    if (this.isShort) {
      if (this.rowsCount && this.rowsCount > 0) {
        this.calendarRows = Array.from({length: this.rowsCount}, (_, i) => i + 1);
      }
      this.calendarCols = environment.mobile ? [1, 2] : [1, 2, 3];
    }
  }
}
